
import Vue from "vue";
import axios from "axios";
import PaginationBar from "@/components/PaginationBar.vue";

export default Vue.extend({
  components: { PaginationBar },
  data: () => ({
    articles: [] as any,
    page: 1,
    totalPage: 0,
    numInOnePage: 20,
    listNeed: {} as Record<string, unknown>,
  }),
  created() {
    const name = this.$route.name ? this.$route.name : "news";
    if (name.startsWith("news") || name.startsWith("recommend")) {
      this.listNeed = { $or: [{ type: "news" }, { type: "recommend" }] };
    } else if (name.startsWith("notice")) {
      this.listNeed = { type: "notice" };
    } else {
      this.listNeed = { $or: [{ type: "news" }, { type: "recommend" }] };
    }
  },
  mounted() {
    axios
      .post(Vue.prototype.apiUrl("get-item-num"), {
        collection: "article",
        need: this.listNeed,
      })
      .then((response) => {
        this.totalPage = Math.ceil((response.data as any).num / this.numInOnePage);
      });
    this.getArticleList();
  },
  watch: {
    page() {
      this.getArticleList();
      window.scrollTo(0, 0);
    },
  },
  methods: {
    formatDate(d: string) {
      try { return new Date(d).toISOString().split("T")[0]; }
      catch { return ""; }
    },
    getArticleList() {
      axios
        .post(Vue.prototype.apiUrl("get-item-list"), {
          collection: "article",
          need: this.listNeed,
          page: this.page,
          numInOnePage: this.numInOnePage,
        })
        .then((response) => {
          this.articles = response.data;
        });
    },
    gotoArticle(type: string, id: string, link: string, content: string) {
      if (link != "") {
        window.location.href = link;
      } else if (type === "recommend" || type === "news") {
        this.$router.push({ path: `/article/news/${id}` });
      } else if (content !== "") {
        this.$router.push({ path: `/article/${type}/${id}` });
      }
    },
  },
});
